const generalReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default generalReducer